import type { WorkSession } from '@/types/workSession.type';
import { WorkSessionStatusBadge } from './WorkSessionStatusBadge';
import { formatDuration } from '@/lib/date.utils';
import { WorkSessionActions } from './WorkSessionActions';
import { Badge } from '../ui/badge';
import { formatTimeFr } from '@/lib/formatTimeFr';
import { isOvernightSession } from '@/lib/workSession.utils';

type Props = {
    session: WorkSession
    onEdit: (session: WorkSession) => void;
    onDelete: (session: WorkSession) => void;
    /** Par défaut comme ton écran actuel */
    startLabel?: string;
    endLabel?: string;
    actionsSize?: "sm" | "md";
}

export const WorkSessionCard = ({session,
    onEdit,
    onDelete,
    startLabel = "Arrivée",
    endLabel = "Départ",
    actionsSize = "sm",
  }: Props) => {
    const startDate = new Date(session.startTime);
    const endDate = session.endTime ? new Date(session.endTime) : null;
    const isOvernight = isOvernightSession(session);
    return (
        <div className="rounded-lg border bg-card p-3 transition-all duration-200 hover:border-primary/30 hover:shadow-sm sm:p-4">
      <div className="space-y-3">
        <div className="flex min-w-0 items-start justify-between gap-2">
          <div className="flex min-w-0 flex-1 items-center gap-16 space-y-2 overflow-hidden sm:gap-14">
            <div className="mb-0 flex items-center gap-2">
              <div>
                <p className="text-xs text-muted-foreground">{startLabel}</p>
                <p className="font-mono text-sm font-medium">
                  {formatTimeFr(startDate)}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div>
                <p className="text-xs text-muted-foreground">{endLabel}</p>
                <p className="flex font-mono text-sm font-medium">
                  {endDate ? formatTimeFr(endDate) : "-"}
                  {isOvernight && (
                    <Badge variant="outline" className="ml-1 text-xs">
                      +1j
                    </Badge>
                  )}
                </p>
              </div>
            </div>
          </div>
          <WorkSessionActions
            session={session}
            onEdit={onEdit}
            onDelete={onDelete}
            size={actionsSize}
          />
        </div>
        <div className="flex flex-wrap items-center gap-2 border-t pt-2">
          <span className="text-xs font-medium">
            {formatDuration(session.duration || 0)}
          </span>
          <WorkSessionStatusBadge session={session} size="xs" />
        </div>
      </div>
    </div>
    );
};

